import React, { useState,useRef } from "react";
import Layout from '../component/Layout/Layout'
import { Form } from "react-bootstrap";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
export default function Contact() {
  const captchaRef = useRef(null)
  const [validated, setValidated] = useState(false);  
  const [errMsg, setErrMsg] = useState({});
  const [state, setState] = useState({name:"",email:"",mobile_number:"", subject:"",message:"" });
  const[submitType, setSubmitType] = useState(0);
  const handleChange = (e) => {
    let value = e.target.value;
    value = value.trimStart();
    setState({
      ...state,
      [e.target.name]: value
    });
  };


  const handleSubmit = async(event) => {
    try {
          event.preventDefault();
          const token = captchaRef.current.getValue();
          const form = event.currentTarget;
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          }
          setValidated(true);
          if(token===''){
            event.preventDefault();
            event.stopPropagation();
            setErrMsg({cls:'alert alert-danger text-center', msg:'Please validate recaptcha.'});
            return;
          }

          if(form.checkValidity()===true) {

            state.token=token
            setSubmitType(1)
            let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/contact/send`,state);
            //console.log(data)
            setSubmitType(3)
            setValidated(false)
            if(data?.status){
              setErrMsg({cls:'alert alert-success text-center', msg:data?.message});
              setState({name:"",email:"",mobile_number:"", subject:"",message:"" });
            }else{
              setSubmitType(0)
              setErrMsg({cls:'alert alert-danger text-center', msg:'Something went wrong, please try again!'});
              setSubmitType(0)
            }
            captchaRef.current.reset();            
            return;
          }
          return false;
    } catch (error) {
      console.error("Error creating post:", error);
    }
  };


  return (
    <Layout title="Contact US | Chaashni by Maansi & Ketan"> 
    <div className="site-content-wrap static-page contact-page">
      <div className="container">      
        <div className="row">
          <h1 className="sustom-heading-h1 col-md-12">Contact <span>Us</span></h1>
          <div className="col-md-12 text-center contact-page-address">            
            {/* <p><strong style={{paddingBottom:"5px", display:"block", fontSize:"16px"}}>Our Postal Address: </strong></p> */}
            <div className="contact-wrap">
            <div className="contact">
              <p className="state"><strong>New Delhi: </strong></p>
              <p className="company-name">Emkay Knits and Knots Pvt. Ltd</p>
              <p>{/* A-14/2, Block A, Nariana Industrial Area Phase-2,
              Naraina, New Delhi, Delhi 110028 */}{/* A-44, Back Side, First Floor, Naraina Industrial Area, Phase-2, New Delhi-110028*/}  Chaashni Couture A-44 (Back Entrance), 1st Floor, Naraina Industrial Area Phase - 2, New Delhi - 110028</p>
              <p><strong>Location:</strong><Link target='_blank' to="https://maps.app.goo.gl/fGS25YeoTNiHvvfZA?g_st=aw"> View on Google Maps</Link></p>
              <p><strong>Email:</strong> <Link target='_blank' to={`mailto:${process.env.REACT_APP_UNIVERSAL_EMAIL_ID}`} className="mailto-box">{process.env.REACT_APP_UNIVERSAL_EMAIL_ID}</Link></p>
          </div>
          <div className="contact">
            <p className="state"><strong>Dubai:</strong></p>
            <p className="company-name">C/O Honey Haute for Readymade Garments Trading LLC</p>
            <p>Shop No. 3, Equiti Arcade, Al Furjan West, Opposite Glamz by Danube Dubai </p>
            <p><strong>Location:</strong><Link target='_blank' to="https://maps.app.goo.gl/VJmoaGHtN6aCHJEq7?g_st=aw"> View on Google Maps</Link></p>
            <p><strong>Email:</strong> <Link target="_blank" to="mailto:customercare@chaashnicouture.ae" className="mailto-box">customercare@chaashnicouture.ae</Link></p>
            </div>
            </div>
          </div>
          
          <div className="col-md-12 contact-page-form">
           <Form noValidate validated={validated} onSubmit={handleSubmit}>             
            
              <div className="row mb-4">
                <div className="col">
                  <input type="text" className="form-control" placeholder="Enter Name" name="name" value={state.name} onChange={handleChange} required />
                </div>
                <div className="col">
                  <input type="email" className="form-control" placeholder="Your Email" name="email" value={state.email} onChange={handleChange} required />
                </div>
              </div>
              <div className="row mb-4">
              <div className="col">
                <input type="text" className="form-control" placeholder="Enter Phone" name="mobile_number" value={state.mobile_number} onChange={handleChange} required />
              </div>
              <div className="col">
                <input type="text" className="form-control" placeholder="Subject" name="subject" value={state.subject} onChange={handleChange} required />
              </div>
            </div>
              <div className="row mb-4">
                <div className="col">
                  <textarea type="text" className="form-control" placeholder="Your message" name="message" value={state.message} onChange={handleChange} required ></textarea>
                </div>
              </div>
              <div className="row mb-4">
              <div className="col captcha-box">
              <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY} 
              ref={captchaRef}
              /> </div>
              </div>
              <div className="row mb-4 contactform-btn-box">
                <div className="col contactform-btn">
                {submitType===0?(
                  <button type="submit" className="btn btn-primary black-btn">Submit</button>
                ):''}  
                {submitType===1?(
                  <button type="submit" className="btn btn-primary black-btn" disabled>Submitting...</button>
                ):''}                 
                {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
                </div>
              </div>
            </Form>
          </div>
          
        </div>
      </div>
    </div>
    </Layout>
  );
}
